import actions from '../../actions/product';

export default [
  '$q', '$window', '$stateParams', '$state', '$scope',
  'OrderService', 'CurrencyService', 'ErrorHandler',
  class OrderSummaryController {
    constructor($q, $window, $params, $state, $scope, OrderService, CurrencyService, ErrorHandler) {
      this._$q = $q;
      this._$window = $window;
      this._$scope = $scope;
      this.order = $params.order;
      this._orderService = OrderService;
      this._errorHandler = ErrorHandler;
      this.currency = CurrencyService;

      this.activeStatuses = [];
      this.processing = true;

      if ($params.order_num && $params.zip) {
        this._orderService.getBaseOrder($params.order_num, $params.zip)
          .then((res) => {
            this.orderObj = res;
            this.order = res.base;
            this.upsells = res.upsells
            this._initOrderSummary();
            _.defer(() => { if ($params.ca) this.changeAddress($params.order_num); });
            $state.go('order-summary', { order_num: null, zip: null, ca: null }, { notify: false, reload: false, location: 'replace' });
          })
          .catch((err) => this._errorHandler.throwError('Order Lookup Error', err && err.data && err.data.message ? err.data.message : 'Encountered an error while attempting to retrieve order.'));
      } else if ($params.order) {
        this.orderObj = $params.order;
        this.order = $params.order.base;
        this.upsells = $params.order.upsells;
        this._initOrderSummary();
      } else {
        $state.go('track-order');
      }
    }

    _initOrderSummary() {
      this.currency.setCountry(this.order.order_customer.address.country);

      this._setActiveStatuses();
      this._calculateDiscount();

      this._fetchOrderHistoryAndShipmentDetails()
        .finally(() => this.processing = false);
    }

    _fetchOrderHistoryAndShipmentDetails() {
      let historyPromise, shipmentPromise,
        tempHistoryPromise, tempShipmentPromise,
        upsellHistoryPromises = [],
        upsellShipmentPromises = [];

      historyPromise = this._orderService.getTrackingHistoryByOrderNumber(this.order.order_num);
      historyPromise
        .then((res) => this.order.history = res)
        .catch((err) => this._errorHandler.throwError('Tracking History Error', 'An error occurred while looking up tracking history.', {
          rawError: err
        }));

      shipmentPromise = this._orderService.getShipmentDetailsByOrderNumber(this.order.order_num);
      shipmentPromise
        .then((res) => {
          this.order.shipment = res;

          if (this.order.shipment && this.order.shipment.courier_tracking_code) {
            this.order.shipment.courier_tracking_code = this.order.shipment.courier_tracking_code.trim();
          }
        })
        .catch((err) => this._errorHandler.throwError('Shipment Error', 'An error occurred while looking up shipment information.', {
          rawError: err
        }));

      if (this.upsells.length) {
        _.forEach(this.upsells, (order) => {
          tempHistoryPromise = this._orderService.getTrackingHistoryByOrderNumber(order.order_num);
          tempHistoryPromise
            .then((res) => order.history = res)
            .catch((err) => this._errorHandler.throwError('Tracking History Error', 'An error occurred while looking up tracking history.', {
              rawError: err
            }));

          tempShipmentPromise = this._orderService.getShipmentDetailsByOrderNumber(order.order_num);
          tempShipmentPromise
            .then((res) => {
              order.shipment = res;

              if (order.shipment && order.shipment.courier_tracking_code) {
                order.shipment.courier_tracking_code = order.shipment.courier_tracking_code.trim();
              }
            })
            .catch((err) => this._errorHandler.throwError('Shipment Error', 'An error occurred while looking up shipment information.', {
              rawError: err
            }));
          upsellHistoryPromises.push(tempHistoryPromise);
          upsellShipmentPromises.push(tempShipmentPromise);
        })
      }

      return this.upsells.length ? this._$q.all(_.flatten([historyPromise, shipmentPromise, upsellHistoryPromises, upsellShipmentPromises])) : this._$q.all([historyPromise, shipmentPromise]);
    }

    formatDate(date) {
      return this._$window.moment(date).format('MM/DD/YY');
    }

    print() {
      this._$window.print();
    }

    sizeDisplay(product) {
      return actions.sizeDisplay(product.campaign_product.product, product.size);
    }

    changeAddress(index) {
      this._$scope.$broadcast('show:changeAddress', index);
    }

    _calculateDiscount() {
      if (this.order && this.order.coupon) {
        let discount = parseFloat(this.order.coupon.discount);
        let discountTotal = 0.0;

        switch (this.order.coupon.discount_type) {
          case 'PERCENTAGE':
            for (let i = 0, product; product = this.order.order_products[i++];) {
              discountTotal += (product.price * product.quantity) * (discount / 100);
            }
            break;
          case 'MONEY':
            discountTotal = discount;
            break;
        }

        this.order.discount = discountTotal;
      }
    }

    _setActiveStatuses() {
      switch (this.order.status) {
        case 'ORDER_PLACED':
          this.activeStatuses = ['APPROVED'];
          break;
        case 'PRINTING':
          this.activeStatuses = ['APPROVED', 'PRINTING'];
          break;
        case 'SHIPPED':
          this.activeStatuses = ['APPROVED', 'PRINTING', 'SHIPPED'];
          break;
        case 'DELIVERED':
          this.activeStatuses = ['APPROVED', 'PRINTING', 'SHIPPED', 'DELIVERED'];
          break;
        default:
          this.activeStatuses = [];
          break;
      }
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/order-summary/order-summary.ctrl.js